import './PageNotFount.css'
import { useNavigate } from "react-router-dom";

function PageNotFount() {
    const navigate = useNavigate();

    return (
        <div className='page_not_fount flex align_center justify_center'>
            <div className='flex flex_column align_center gap_20'>
                <h1 className='gray_scale_2 font_weight_600'>404 Page Not Found</h1>
                <div className='green_1 cursor_pointer' onClick={() => {
                    navigate(`/`);
                }}>
                    <p className='font_size_18'>Back to dashboard</p>
                </div>
            </div>
        </div>
    );
}

export default PageNotFount;